import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from '../../../entities/user/types';

interface UserState {
  users: Record<string, User>;
  currentUser: User | null;
}

const initialState: UserState = {
  users: {},
  currentUser: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<User>) => {
      state.users[action.payload.id] = action.payload;
    },
    updateUser: (state, action: PayloadAction<User>) => {
      if (action.payload.id in state.users) {
        state.users[action.payload.id] = action.payload;
      }
    },
    removeUser: (state, action: PayloadAction<string>) => {
      delete state.users[action.payload];
      if (state.currentUser && state.currentUser.id === action.payload) {
        state.currentUser = null;
      }
    },
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
    },
  },
});

export const { addUser, updateUser, removeUser, setCurrentUser } = userSlice.actions;
export default userSlice.reducer;